export const gettingStartedRoutName = 'user.gettingStarted'
export type gettingStartedRoutNameType = typeof gettingStartedRoutName
